import { hasVendorGrant } from '../util/gdpr_consent'

up.compiler('[data-blockable-iframe]', (containerDiv) => {
  const vendorName = containerDiv.dataset.vendor
  let iframe: HTMLIFrameElement | undefined

  updateConsent()
  const destructor = up.on('gdpr:vendor-grant-changed', updateConsent)

  return destructor

  function updateConsent() {
    if (hasVendorGrant(vendorName!)) {
      insertIframeInContainer()
    } else {
      removeIframe()
    }
  }

  function insertIframeInContainer() {
    if (iframe) {
      return
    }

    containerDiv.setAttribute('hidden', 'hidden')

    iframe = buildIframe(getIframeSrc(), getIframeAttributes())

    containerDiv.parentNode!.insertBefore(iframe, null)
  }

  function removeIframe() {
    containerDiv.removeAttribute('hidden')

    iframe?.remove()
    iframe = undefined
  }

  function getIframeSrc() {
    return containerDiv.dataset.blockableIframe!
  }

  function getIframeAttributes() {
    return JSON.parse(containerDiv.dataset.iframeAttributes!)
  }
})

function buildIframe(src: string, attributes: Record<string, string> = {}) {
  const iframe = document.createElement('iframe')
  for (const [attribute, value] of Object.entries(attributes)) {
    iframe.setAttribute(attribute, value)
  }
  iframe.setAttribute('src', src)

  return iframe
}
